export default "__VITE_ASSET__543efb28__"